import classNames from 'classnames'
import {connect, ConnectedProps} from 'react-redux'
import {createStructuredSelector} from 'reselect'
import React from 'react'

import * as pdp from '../../store/productDetailPage'
import {advancedPdpImageClicked} from '../../track/track'
import {SetImage, DisplayedProduct} from '../Product/types'
import '../../../scss/components/pieces/_product-thumbnails.scss'

interface Props extends PropsFromRedux {
  displayedProduct: DisplayedProduct
  modifier: string
  onClick: (index: number) => void
  productImages: SetImage[]
}
const ProductThumbnails = ({
  currentZoomImageIndex,
  displayedProduct: {id, name},
  modifier,
  onClick,
  productImages,
}: Props) => (
  <div
    className={classNames('c-product-thumbnail', {[`c-product-thumbnail--${modifier}`]: modifier})}
  >
    {productImages.map((image, index) => (
      <button
        className={classNames(`c-product-thumbnail__tile`, {
          'is--selected': index === currentZoomImageIndex,
        })}
        key={image.id}
        onClick={() => {
          onClick(index)
          advancedPdpImageClicked(image.position - 1, name, id, 'thumbnails')
        }}
      >
        <span className="u-sr-only">Display this image in carousel</span>
        <span className="o-frame">
          <span className="o-frame__canvas">
            <img
              className="o-frame__media"
              alt={image.name}
              src={`${image.url}?width=60`}
              srcSet={`${image.url}?width=60, ${image.url}?width=120 2x`}
            />
          </span>
        </span>
      </button>
    ))}
  </div>
)

const mapStateToProps = createStructuredSelector({
  currentZoomImageIndex: pdp.currentZoomImageIndex,
})
const connector = connect(mapStateToProps)
type PropsFromRedux = ConnectedProps<typeof connector>

export default connector(ProductThumbnails)
